export default {
  cn: {
    authOption: {
      emptyBtn:"清空",
      selectBtn:"全选",
      resetBtn: "重置",
      title:"添加角色",
      crumbs: {
        newaAccount: "权限管理",
        amend: "权限管理",
      },
      sales: {
        title: '权限管理',
      },
      changeBtn: '保存修改',
      logOut: {
        yes: '确定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "请正确填写信息",
        role_error: "请确认此角色下面是否存在用户",
      }
    }
  },
  hk: {
    authOption: {
      emptyBtn:"清空",
      selectBtn:"全選",
      resetBtn: "重置",
      title:"添加角色",
      crumbs: {
        newaAccount: "權限管理",
        amend: "權限管理",
      },
      sales: {
        title: '權限管理',
      },
      changeBtn: '保存修改',
      logOut: {
        yes: '確定',
        no: '取消'
      },
      submitResult: {
        succeed: "保存成功",
        err: "請正確填寫信息",
        role_error: "請確認此角色下面是否存在用戶",
      }
    }
  },
  en: {
    authOption: {
      emptyBtn:"empty",
      selectBtn:"all select",
      resetBtn: "reset",
      title:"add role",
      crumbs: {
        newaAccount: "auth option",
        amend: "auth option",
      },
      sales: {
        title: 'auth option',
      },
      changeBtn: 'save modify',
      logOut: {
        yes: 'Sure',
        no: 'Cancel'
      },
       submitResult: {
        succeed: "save successfully",
        err: "Please fill in the information correctly",
        role_error: "Please confirm if there is a user under this role",
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/authOption.js